import React, { useState, useEffect } from "react";
import "./Maze1.css";
import correctSound from "./sounds/correct.mp3";
import wrongSound from "./sounds/wrong.wav";
import winSound from "./sounds/win.mp3";

const levels = [
  [
    ["😀", "🟩", "🟩", "🏁"],
    ["🟥", "🟩", "🟥", "🟥"],
    ["🟩", "🟩", "🟩", "🟥"]
  ],
  [
    ["😀", "🟩", "🟥", "🟩", "🏁"],
    ["🟥", "🟩", "🟩", "🟩", "🟥"],
    ["🟩", "🟥", "🟩", "🟥", "🟩"],
    ["🟩", "🟩", "🟩", "🟩", "🟩"]
  ],
  [
    ["😀", "🟩", "🟥", "🟩", "🟩", "🏁"],
    ["🟥", "🟩", "🟥", "🟩", "🟥", "🟩"],
    ["🟩", "🟩", "🟩", "🟩", "🟩", "🟩"],
    ["🟥", "🟩", "🟥", "🟩", "🟥", "🟩"]
  ]
];

const Maze1 = () => {
  const [level, setLevel] = useState(0);
  const [player, setPlayer] = useState({ x: 0, y: 0 });
  const [moves, setMoves] = useState(0);
  const [startTime, setStartTime] = useState(Date.now());
  const [scoreboard, setScoreboard] = useState([]);

  const maze = levels[level];

  const playSound = (file) => new Audio(file).play();

  const move = (dx, dy) => {
    const newX = player.x + dx;
    const newY = player.y + dy;
    if (maze[newY] && maze[newY][newX] && maze[newY][newX] !== "🟥") {
      setPlayer({ x: newX, y: newY });
      setMoves((m) => m + 1);
      playSound(correctSound);
      if (maze[newY][newX] === "🏁") {
        playSound(winSound);
        const timeTaken = Math.floor((Date.now() - startTime) / 1000);
        setScoreboard((sb) => [
          ...sb,
          { level: level + 1, moves: moves + 1, time: timeTaken }
        ]);
        setTimeout(() => {
          alert(`🎉 Level ${level + 1} complete! Moves: ${moves + 1}, Time: ${timeTaken}s`);
        }, 500);
      }
    } else {
      playSound(wrongSound);
    }
  };

  // Keyboard controls (desktop)
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowUp") move(0, -1);
      if (e.key === "ArrowDown") move(0, 1);
      if (e.key === "ArrowLeft") move(-1, 0);
      if (e.key === "ArrowRight") move(1, 0);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [player, level, moves]);

  const selectLevel = (idx) => {
    setLevel(idx);
    setPlayer({ x: 0, y: 0 });
    setMoves(0);
    setStartTime(Date.now());
  };

  // Touch-to-move: tap a cell adjacent to player
  const handleCellTap = (x, y) => {
    const dx = x - player.x;
    const dy = y - player.y;
    if (Math.abs(dx) + Math.abs(dy) === 1) {
      move(dx, dy);
    }
  };

  return (
    <div className="maze">
      <h2>Level {level + 1}</h2>
      <div className="level-selector">
        {levels.map((_, idx) => (
          <button
            key={idx}
            className={level === idx ? "active" : ""}
            onClick={() => selectLevel(idx)}
          >
            Level {idx + 1}
          </button>
        ))}
      </div>

      {maze.map((row, y) => (
        <div key={y} className="row">
          {row.map((cell, x) => (
            <span
              key={x}
              className="cell"
              onClick={() => handleCellTap(x, y)} // tap to move
            >
              {player.x === x && player.y === y ? "😀" : cell}
            </span>
          ))}
        </div>
      ))}

      {/* On-screen arrow buttons for mobile */}
      <div className="controls">
        <button onClick={() => move(0, -1)}>⬆️</button>
        <div>
          <button onClick={() => move(-1, 0)}>⬅️</button>
          <button onClick={() => move(1, 0)}>➡️</button>
        </div>
        <button onClick={() => move(0, 1)}>⬇️</button>
      </div>

      <div className="scoreboard">
        <h3>🏆 Scoreboard</h3>
        <ul>
          {scoreboard.map((entry, i) => (
            <li key={i}>
              Level {entry.level}: {entry.moves} moves, {entry.time}s
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Maze1;
